import { styled } from '@slal/ui';
import { breakpointUp } from '@slal/ui/helpers';
import { P, Text } from '@slal/ui/typography';

export const StyledForm = styled.form`
    h2 {
        margin: 0;
        margin: 16px 0 0 24px;
        font-size: ${({ theme }) => theme.fontSizes[10]};
        ${breakpointUp.sm`
          margin-left: 0;
        `}
    }
`;

export const StyledPhoneNumber = styled(Text)`
    font-size: ${({ theme }) => theme.fontSizes[6]};
`;

export const StyledOpeningHours = styled.div`
    margin: ${({ theme }) => theme.space[4]} 0 0;
    font-size: ${({ theme }) => theme.fontSizes[6]};
    h2,
    h3,
    h4,
    h5 {
        margin: 0;
        font-weight: ${({ theme }) => theme.fonts.sansSerif.fontWeights.regular};
    }
    p {
        margin: 0;
        font-size: ${({ theme }) => theme.fontSizes[3]};
    }
`;

export const StyledApplicationButtonsWrapper = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.space[4]};
`;

export const EstimatedCompletionTime = styled(Text)`
    display: flex;
    color: ${({ theme }) => theme.colors.neutral__dark__20};
    justify-content: center;
    align-items: center;
    gap: ${({ theme }) => theme.space[4]};
    margin-left: ${({ theme }) => theme.space[5]};
`;

export const StyledHelpPhoneNumber = styled(P)`
    display: flex;
    gap: ${({ theme }) => theme.space[4]};
    padding-top: ${({ theme }) => theme.space[4]};
    font-weight: ${({ theme }) => theme.fonts.headings.fontWeights.regular};
`;
